import Api from '@/services/Api'

export default {
  get (params) {
    return Api().get('to-do', { params })
  },

  view (params) {
    return Api().get(`to-do/${params.id}`)
  },

  post (data) {
    return Api().post('to-do', data)
  },

  put (data) {
    return Api().put(`to-do/${data.id}`, data)
  },

  delete (id) {
    return Api().delete(`to-do/${id}`)
  }
}
